

















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Spinner extends Vue {
  @Prop({ default: '#337ac6' }) color!: string
  @Prop({ default: 64 }) height!: number
  @Prop({ default: 64 }) width!: number
}
